/**
 * Neutral segmented control per Aurora §6: `--surface-2` track with a 3px
 * inset; the active segment lifts onto `--surface` + `--shadow-sm`.
 *
 * Extracted from AppearanceSettings when Profile settings needed the same
 * control for the landing-app choice. Wraps to a second line rather than
 * overflowing, since four options with labels like "K-OS Finance" are wider
 * than Appearance's three-option rows.
 */

import styles from './Segmented.module.css';

export interface SegmentedProps<T extends string> {
  ariaLabel: string;
  value: T;
  options: readonly { value: T; label: string }[];
  onChange: (value: T) => void;
}

export function Segmented<T extends string>({
  ariaLabel,
  value,
  options,
  onChange,
}: SegmentedProps<T>) {
  return (
    <div className={styles.segmented} role="radiogroup" aria-label={ariaLabel}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={value === opt.value}
          className={`${styles.segBtn} ${value === opt.value ? styles.segBtnActive : ''}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
